import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from './../layout/Dashboard';
import { hideNotification } from '../../store/actions/notification';
import { OrganizationsTable } from "../../components/pages/organizations/OrganizationsTable";
import { OrganizationsExport } from "../../components/pages/organizations/OrganizationsExport";
import { Messages } from "../../components/layout/Messages/Messages";
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { NOTIFICATION_ARCHIVE_SERVICE_ACTIONS } from 'config/notifications';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './Organizations.scss';

function OrganizationsComponent(props) {
  const canExport = ACL.CLIENT.ORGANIZATIONS.EXPORT.hasAccess();
  const canList = ACL.CLIENT.USERS.LIST.hasAccess();

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="organizations-list-workspace">
        <PageHeader title={<FormattedMessage id="pages.organizations.title"/>}/>
        <div className="organizations-list-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_ARCHIVE_SERVICE_ACTIONS}/>
        </div>
        <PageSurface className="organizations-list-surface">
          {canExport && <OrganizationsExport/>}
          {canList ? <OrganizationsTable/> : <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const mapStateToProps = state => ( {} );

const Organizations = connect( mapStateToProps, { hideNotification } )( OrganizationsComponent );

export { Organizations, OrganizationsComponent };
